import axios from 'axios';
import store from '../store';
import queryString from 'query-string';
import {API_ROOT, CHROME_EXT_ID, SM_URL, urlParam, authReturnUrl, getCookie} from '../app/utils';
import {getSharingDetailsPopup} from './sharingDetailsActions';
import {
	isProfileUpdatePropagationPopup
} from './popupActions';
import {msgBar} from './msgBarActions';
import {loadPermissions} from './permissionActions';
import {fetchSuspiciousContactsDeletion} from './suspiciousContactsDeletionActions';
import {webfulIdentify} from '../app/utils/webful';


/**
 * If NotRegistered -> onSMSignIn is called
 *
 * @param googleUserId
 * @param isAdmin
 * @param domain
 * @param installType
 * @returns {Function}
 **/

export function onSMSignIn(googleUserId, isAdmin, domain, installType) {
	return function (dispatch, getState) {

		let queryParameter = queryString.parse(window.location.search);
		const profile = getState().profileReducer.getProfile || {};
		const safeDomain = domain || '';

		let smSignInRequestPayload = {
			name: profile.name || '',
			contactEmail: profile.email || '',
			googleId: googleUserId,
			isAdmin: isAdmin,
			role: profile.role || '',
			pictureUrl: profile.pictureUrl || '',
			landingSite: urlParam('landingSite') ? urlParam('landingSite') : 'GSC APP',
			landingPage: urlParam('landingPage') ? urlParam('landingPage') : window.location.pathname !== '/' ? window.location.pathname : 'homepage',
			webSource: urlParam('webSource') || 'Install',
			form: urlParam('form'),
			url: urlParam('src'),
			origin: urlParam('src') === 'gsminstall' ? 'gsminstall' : urlParam('origin'),
			install_type: installType,
			website: safeDomain.includes('gmail.com') ? '' : safeDomain.length ? 'www.' + safeDomain : '',
			language: Object.keys(queryParameter).length > 0 ? queryParameter?.language : navigator.language ? navigator.language : 'en-US'
		};

		axios.post(API_ROOT + '/api/util/logs', {
			source : "URLSentToSMSignInApi",
			data : JSON.stringify(smSignInRequestPayload)
		}, {withCredentials: true});

		axios.post(SM_URL + '/api/products/gsc/users/sign_in', smSignInRequestPayload).then(response => {

			dispatch({
				type: 'IS_SM_SIGNIN_READY',
				payload: true
			});

			dispatch({
				type: 'GET_SM_USER',
				payload: [
					response.data.userId,
					response.data.userToken
				]
			});

			if (response.data && response.data.dataLayer) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'logGSCWeb',
					'userGroup': response.data.dataLayer.userGroup,
					'userType': response.data.dataLayer.userType,
					'googleEdition': response.data.dataLayer.googleEdition,
					'userVertical': response.data.dataLayer.userVertical,
					'installPlatform': response.data.dataLayer.installPlatform,
					'userAccountType': response.data.dataLayer.userAccountType,
					'userCountry': response.data.dataLayer.userCountry,
					'userLanguage': response.data.dataLayer.userLanguage,
					'userId': response.data.dataLayer.userId,
				});
			}

			/*
			* From invitaton where no register popup is available
			* */

			const currentProfile = getState().profileReducer.getProfile || {};
			if (currentProfile.status === 'invitedNotRegisteredNotGranted'
				|| currentProfile.status === 'invitedNotRegisteredGranted'){
				dispatch(onSMUserUpdate(response.data.userId, response.data.userToken, installType, isAdmin))
			}


		}).catch(e => {
			console.error(e);
		})
	}
}

/**
 * If Registered but Invited onSMUserUpdate is called
 *
 * @param userId
 * @param userToken
 * @param installType
 * @param isAdmin
 * @returns {Function}
 **/

export function onSMUserUpdate (userId, userToken, installType, isAdmin) {
	return function (dispatch, getState) {
		const profile = getState().profileReducer.getProfile || {};
		axios.put(SM_URL + '/api/products/gsc/users/' + userId + '?format=json', {
			'contactEmail': profile.email,
			'phoneNumber': '',
			'name': profile.name,
			'googleId': profile.id,
			'registered': true,
			'installStatus': 'Registered',
			'installType': installType,
			'userId': userId,
			'userToken': userToken,
			'isAdmin': isAdmin,
			'role': profile.role,
			'fbp': getCookie('_fbp'),
			'fbc': getCookie('_fbc'),
			'metaEventId': getCookie('_gsc_meta_event_id'),
			'firstName': profile.given_name || profile.firstName,
			'lastName': profile.family_name || profile.lastName,
		}, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'user-token ' + getState().profileReducer.getSmUser[1]
			}
		}).then(response => {

			if (response.status === 200) {
				if (window.dataLayer) {
					window.dataLayer.push({
						'registered': 'true',
						event: 'registered'
					});
				}
				dispatch(getProfile());
			}

		});
	}
}

export function getProfile(inspectlet) {

	return function (dispatch, getState) {

		let requestUrl = API_ROOT + '/api/profile';
		let searchParams = window.location.search;
		if (searchParams) {
			if (searchParams.includes('user=')) {
				searchParams = searchParams.replace(/([?&])user=/i, '$1impersonate=');
			}
			if (searchParams.includes('impersonate')) {
				requestUrl += searchParams;
			}
		}
		axios.get(requestUrl, {withCredentials: true}).then(response => {

			dispatch({
				type: 'GET_PROFILE',
				payload: response.data
			});

			let domainValue = '';
			let statusValue = '';

			if (response.data.email && response.data.email.includes('gmail.com')) {
				domainValue = response.data.email.replace('@', '__');
			} else if (response.data.email) {
				if (response.data.domain !== null && response.data.domain !== undefined) {
					domainValue = response.data.domain.name;
					statusValue = response.data.domain.status;
				} else {
					domainValue = response.data.email.split('@')[1];
				}
			}

			if (inspectlet) {
				if (typeof window.__insp !== 'undefined' && typeof window.__insp.push === 'function') {
					window.__insp.push(['tagSession', {
						site: 'gsc-react',
						domain: domainValue,
						gscStatus: statusValue
					}]);
				}
			}


			// Webful In-App Analytics — identify user
			webfulIdentify(response.data.id, {
				plan: response.data.domain?.status,
				role: response.data.role
			});

			if (response.data.domain !== null) {
				// if (response.data.domain.status === 'EXPIRED_EVAL' && response.data.trialStatus === 'Eligible' (!('action' in store.getState().profileReducer.setGmailAddOnData))) {
				// console.log("expired>>>>>>>",response.data)
				// 	//	dispatch(getSharingDetailsPopup([true, 'expired_eval']));
				// }

				if (response.data.domain.status === 'EXPIRED_PAID' && (!('action' in store.getState().profileReducer.setGmailAddOnData))) {
					dispatch(getSharingDetailsPopup([true, 'expired_paid']));
				}
			}

			if (response.data.status) {

				if (window.dataLayer) {
					window.dataLayer.push({
						'authentifiedGmail': 'true',
						event: 'authentifiedGmail'
					});
				}
				axios.post(API_ROOT + '/api/util/logs', {
					source : "URLFromGSCBackend",
					data : window.location.href
				}, {withCredentials: true});


				if (response.data.status === 'notRegisteredNotGranted' || response.data.status === 'notRegisteredGranted') {

					if ((response.data.status.includes('NotGranted') === false) && window.dataLayer) {
						window.dataLayer.push({
							'granted': 'true',
							event: 'granted'
						});
					}

					if (urlParam('page') && urlParam('page') === 'try') {

						/*
						* Data caught from GSC website
						* */

						return;
					}

					/*
					* Direct Access
					* */

					dispatch(onSMSignIn(response.data.id, response.data.isAdmin, domainValue, 'Try'));

				} else if (
					response.data.status === 'invitedNotRegisteredNotGranted'
					|| response.data.status === 'invitedNotRegisteredGranted'
				) {

					if(window.location.pathname.includes('/invited/invitation-response') === false){
						dispatch(onSMSignIn(response.data.id, response.data.isAdmin, domainValue, 'SignUp'));
					}

				} else if (response.data.status === 'invitedRegisteredNotGranted') {

					dispatch(onSMSignIn(response.data.id, response.data.isAdmin, domainValue, 'SignUp'));
					window.location.href = API_ROOT + '/account/access-offline?authuser=' + response.data.email + '&redirect=' + encodeURIComponent(authReturnUrl(window.location.pathname + window.location.search));

				} else if (response.data.status === 'registeredNotGranted') {

					/*
					* Update for SM to know in case user is GW Admin
					* */

					dispatch(onSMSignIn(response.data.id, response.data.isAdmin, domainValue, 'Try'));

				} else {

					/*
					* registeredGranted or invitedRegisteredGranted
					* */

					/*
					* Update for SM to know in case user is GW Admin
					* */

					dispatch(onSMSignIn(response.data.id, response.data.isAdmin, domainValue, 'Try'));

					/*
					* Load all the front-end permissions related to Profile API response
					* */

					dispatch(loadPermissions());

					/*
					* Check contact deletion
					* */

					dispatch(fetchSuspiciousContactsDeletion());

					if (window.dataLayer) {

						window.dataLayer.push({
							'granted': 'true',
							event: 'granted'
						});
					}

				}
			}

			const isExtInstalled = localStorage.getItem('chromeExtensionUser') === 'true' || localStorage.getItem('chromeExtensionUser') === true || document.documentElement.dataset?.gscInstalled === 'true';
			dispatch({
				type: 'IS_CHROME_EXT_INSTALLED',
				payload: Boolean(isExtInstalled)
			});

		}).catch(error => {
			console.error("Error in getProfile:", error);
			window.location.href = API_ROOT + '/account/login?redirect=' + encodeURIComponent(authReturnUrl(window.location.pathname + window.location.search));
		});
	}
}

export function putProfile(object) {
	return function(dispatch){
		axios.put(API_ROOT + '/api/profile', object, {withCredentials: true}).then((response) => {
			dispatch(isLoadingProfileChange(false));
			dispatch(getProfile(true));
			dispatch(msgBar(['success', 'Your profile has been updated.']));
			dispatch(isEditModeProfile(false));
			dispatch(isProfileUpdatePropagationPopup(true));
		}).catch((e) => {
			dispatch(isLoadingProfileChange(false));
			dispatch(msgBar(['error', 'Error on updating profile: ' + e.response.data]));
			dispatch(isEditModeProfile(false))
		});
	}
}

export function restoreDomain () {
	return function (dispatch) {
		axios.put(API_ROOT + '/api/v1/account/restore', undefined, {withCredentials: true}).then((response) => {
			setTimeout( () => {
				dispatch(getProfile(true));
			}, 1000)
		}).catch((e) => {
			console.error('Unable to restore the domain');
		});
	}
}

export function putAvatarProfile(string) {
	return function(dispatch){
		axios.put(API_ROOT + '/api/profile/photo', {
			"pictureUrl": string
		}, {withCredentials: true}).then((response) => {
			//console.log(response);
		}).finally(() => {
			dispatch(profileAvatarToUpload(""))
		})
	}
}

export function profileAvatarToUpload (string) {
	return {
		type: 'PROFILE_AVATAR_TO_UPLOAD',
		payload: string
	}
}

export function submitRegister(boolean) {
	return {
		type: 'SUBMIT_REGISTER',
		payload: boolean
	}
}

export function isAnsweredChromeExtInstallRequest(boolean) {
	return {
		type: 'IS_ANSWERED_CHROME_EXT_INSTALL_REQUEST',
		payload: boolean
	}
}

export function showIntegrateGoogleButton(boolean) {
	return {
		type: 'SHOW_INTEGRATE_GOOGLE_BUTTON',
		payload: boolean
	}
}


export function setGmailAddOnData(object) {
	return {
		type: 'GMAIL_ADD_ON_DATA',
		payload: object,
	};
}

export function setActiveLabel(string) {
	return {
		type: 'CHECK_ACTIVE_GMAIL_ADD_ON_LABEL',
		payload: string,
	};
}

export function setgmailAddOnFromMarketPlace(string) {
	return {
		type: 'SET_GMAIL_ADD_ON_FROM_MARKET_PLACE',
		payload: string
	}
}

export function sharingPageReady(boolean) {
	return {
		type: 'SHARING_PAGE_READY',
		payload: boolean
	}
}

export function isEditModeProfile(boolean) {
	return {
		type: 'IS_EDIT_MODE_PROFILE',
		payload: boolean
	}
}

export function isLoadingProfileChange(boolean) {
	return {
		type: 'IS_LOADING_PROFILE_CHANGE',
		payload: boolean
	}
}

export function postSwitchToFree () {
	return function (dispatch) {
		return axios.post(`${API_ROOT}/api/domain/switch-to-free`, {}, {withCredentials: true}).then(() => {
			window.location.reload();
		}).catch((err) => {
			throw err;
		})
	}
}
